import "./MobileNavigation.css";

import React from "react";

import { useRef, useState } from "react";

import { Link } from "react-router-dom";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export const MobileNavigation = ({
  divWidth,
  mobileNavHideFunction,
  currentItemsCount,
}) => {
  const mobileNavigationButton1 = useRef(null);
  const mobileNavigationButton2 = useRef(null);
  const mobileNavigationButton3 = useRef(null);
  const mobileNavigationButton4 = useRef(null);

  const [mobileNavigationButton1IsOpen, setMobileNavigationButton1IsOpen] =
    useState(false);
  const [mobileNavigationButton2IsOpen, setMobileNavigationButton2IsOpen] =
    useState(false);
  const [mobileNavigationButton3IsOpen, setMobileNavigationButton3IsOpen] =
    useState(false);
  const [mobileNavigationButton4IsOpen, setMobileNavigationButton4IsOpen] =
    useState(false);

  const closeClick = () => {
    mobileNavHideFunction(0);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const closeClickBottom = () => {
    mobileNavHideFunction(0);
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };
  // const handleExpandButton1 = () => {
  //   if (mobileNavigationButton1IsOpen === false) {
  //     setMobileNavigationButton1IsOpen(true);
  //     mobileNavigationButton1.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "100rem";
  //   } else {
  //     mobileNavigationButton1.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "4rem";
  //     setMobileNavigationButton1IsOpen(false);
  //   }
  // };
  // const handleExpandButton2 = () => {
  //   if (mobileNavigationButton2IsOpen === false) {
  //     setMobileNavigationButton2IsOpen(true);
  //     mobileNavigationButton2.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "100rem";
  //   } else {
  //     setMobileNavigationButton2IsOpen(false);
  //     mobileNavigationButton2.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "4rem";
  //   }
  // };
  // const handleExpandButton3 = () => {
  //   if (mobileNavigationButton3IsOpen === false) {
  //     setMobileNavigationButton3IsOpen(true);
  //     mobileNavigationButton3.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "100rem";
  //   } else {
  //     setMobileNavigationButton3IsOpen(false);
  //     mobileNavigationButton3.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "4rem";
  //   }
  // };
  // const handleExpandButton4 = () => {
  //   if (mobileNavigationButton4IsOpen === false) {
  //     setMobileNavigationButton4IsOpen(true);
  //     mobileNavigationButton4.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "100rem";
  //   } else {
  //     setMobileNavigationButton4IsOpen(false);
  //     mobileNavigationButton4.current.parentElement.parentElement.parentElement.style.maxHeight =
  //       "4rem";
  //   }
  // };
  return (
    <div
      style={{ width: `${divWidth}%` }}
      className="mobile-navigation-container"
    >
      <div className="mobile-navigation-content">
        <div className="mobile-navigation-close-button-container">
          <button
            className="mobile-navigation-close-button"
            disabled={false}
            onClick={closeClick}
          >
            X
          </button>
        </div>

        <div className="mobile-navigation-link">
          <div className="mobile-navigation-link-text">
            <Link
              to={"/"}
              onClick={closeClick}
              className="mobile-navigation-link-text-main"
            >
              Начало
              <div className="mobile-navigation-link-arrow">
                <ArrowForwardIosIcon
                  ref={mobileNavigationButton1}
                  sx={{ fontSize: "11px" }}
                />
              </div>
            </Link>
          </div>
        </div>
        <div className="mobile-navigation-link">
          <div className="mobile-navigation-link-text">
            <Link
              to={"/about-us"}
              onClick={closeClick}
              className="mobile-navigation-link-text-main"
            >
              За нас
              <div className="mobile-navigation-link-arrow">
                <ArrowForwardIosIcon
                  ref={mobileNavigationButton2}
                  sx={{ fontSize: "11px" }}
                />
              </div>
            </Link>
          </div>
        </div>
        <div className="mobile-navigation-link">
          <div className="mobile-navigation-link-text">
            <Link
              to={"/shop"}
              onClick={closeClick}
              className="mobile-navigation-link-text-main"
            >
              Каталог
              <div className="mobile-navigation-link-arrow">
                <ArrowForwardIosIcon
                  ref={mobileNavigationButton3}
                  sx={{ fontSize: "11px" }}
                />
              </div>
            </Link>
          </div>
        </div>

        <div className="mobile-navigation-link">
          <div className="mobile-navigation-link-text">
            <Link
              to={"/gallery"}
              onClick={closeClick}
              className="mobile-navigation-link-text-main"
            >
              Галерия
              <div className="mobile-navigation-link-arrow">
                <ArrowForwardIosIcon
                  ref={mobileNavigationButton3}
                  sx={{ fontSize: "11px" }}
                />
              </div>
            </Link>
          </div>
        </div>

        <div className="mobile-navigation-link">
          <div className="mobile-navigation-link-text">
            <a
              // to={"/about-us"}
              onClick={closeClickBottom}
              className="mobile-navigation-link-text-main"
              href="#"
            >
              Контакти
              <div className="mobile-navigation-link-arrow">
                <ArrowForwardIosIcon
                  ref={mobileNavigationButton3}
                  sx={{ fontSize: "11px" }}
                />
              </div>
            </a>
          </div>
        </div>

        <div className="mobile-cart-navigation-link">
          <div className="mobile-cart-navigation-link-number">
            {currentItemsCount}
          </div>
          <ShoppingCartIcon sx={{ fontSize: "36px", mr: "2rem" }} />

          <Link
            to={"/cart"}
            onClick={closeClick}
            className="mobile-cart-navigation-link-actual"
          >
            Количка
          </Link>
        </div>
      </div>
    </div>
  );
};
